import React, {useEffect, useRef, useState} from 'react';
import {Col, Form, Input, message, Row,} from 'antd';
import {ProForm, ProFormInstance} from '@ant-design/pro-form';
import {WdiCardTitle, wdiCore, WdiModalAppResult} from '@/components/WdiControls';
import {FormPageProps} from '@/components/WdiBus/FormPage';
import {ApplyFooter, ApplyFooterType} from '@/components/WdiBus/ApplyFooter';
import {FileUploadUtility, WdiFileUpload} from '@/components/WdiControls/WdiFileUpload';
import {Enum} from '@/enums/system';
import {ResponseStatus} from '@/utils/request';
import {PageType} from '@/services/basic/pagetype';
import {FormSs} from '@/services/sales/ss';
import DataStore from '@/components/GridWidget/DataStore'
import {initApplyPageContext, ViewEntityProps} from '../../components/data';
import GeneralSettleDetailsForApplyApp from './details';
import FormSaInfosApp from '../../../sa/components/FormSaInfos';
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import {WarningInfoAppProps} from "@/components/WdiBus/PanelForWarning";
import SsWarningInformation from "@/pages/sales/ss/components/SsWarningInformation";
import {WdiEditor} from "@/components/WdiControls/WdiEditor";

const {TextArea} = Input;
const getPageResult = (values: any, viewEntity: ViewEntityProps, pageType: API.PageType, statusId: number, dataSource: any[]) => {

  const result: WdiModalAppResult = {code: ResponseStatus.UNKNOWN};

  const {fileInfo, settleMaterial, ...entity} = values;

  if (FileUploadUtility.isUploading(fileInfo)) {
    result.message = '附件正在上传中!';
    return result;
  }

  if (FileUploadUtility.isError(fileInfo)) {
    result.message = '附件存在错误文件!';
    return result;
  }

  const req: { form: any, formSs: any, formSsDetails: any[] } = {
    form: {
      statusId: statusId,
      pageTypeId: pageType.pageTypeId,
      pageGroupId: pageType.pageGroupId,
      formTypeId: viewEntity.formTypeId,
    },
    formSs: {},
    formSsDetails: []
  };

  if (viewEntity.formSs) {
    if (viewEntity.relationType === Enum.FormRelationType.REJECTED) {
      req.form.relatedFormId = viewEntity.relatedFormId;
      req.form.relationType = viewEntity.relationType;
    } else {
      req.form.formId = viewEntity.formId;
    }
  }

  const info = FileUploadUtility.serialize(fileInfo);
  entity.fileName = info?.names;
  entity.filePath = info?.urls;
  entity.formSaId = viewEntity.formSaId;
  entity.formSsId = viewEntity.formSs?.formSsId;

  if (settleMaterial) {
    entity.settleMaterial = settleMaterial.join();
  }
  req.formSs = entity;

  req.formSsDetails = dataSource;

  let isOk = true;
  if (req.formSsDetails && req.formSsDetails.length > 0) {
    for (let i = 0; i < req.formSsDetails.length; i++) {
      const detailRow = req.formSsDetails[i];
      detailRow.rowNumber = i + 1;
      detailRow.formSsDetailId = detailRow.formSsDetailId || 0;
      detailRow.formSsId = detailRow.formSsId || 0;
      if (wdiCore.Object.IsNullOrUndefined(detailRow.amount)) {
        isOk = false;
        result.message = `第${detailRow.rowNumber}行，请填写结案金额`;
        break;
      }
    }
  } else {
    isOk = false;
    result.message = `费用明细不能为空`;
    return result;
  }
  if (!isOk) {
    return result;
  }

  result.data = req;
  result.code = ResponseStatus.SUCCESS;
  return result;
}

const GeneralSettleApplyApp: React.FC<FormPageProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const [entity, setEntity] = useState<ViewEntityProps>();
  const [pageType, setPageType] = useState<API.PageType>();
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [warningSettings, setWarningSettings] = useState<WarningInfoAppProps>({visible: false});
  const [editorRef,setEditorRef] = useState<any>();

  const onDetailsChange = (data: any) => {
    setDataSource(data);
  };

  useEffect(() => {
    (async () => {
      const params = props.data;
      if (params) {
        const result = await initApplyPageContext(params);
        if (result.code !== ResponseStatus.SUCCESS) {
          message.error(result.message);
          return;
        }
        const viewEntity: ViewEntityProps = result.data;
        if (viewEntity.formSs) {
          formRef.current?.setFieldsValue({
            settleMaterial: viewEntity.formSs.settleMaterial?.split(','),
            remark: viewEntity.formSs.remark,
            differenceDesc: viewEntity.formSs.differenceDesc,
            fileInfo: FileUploadUtility.parse(viewEntity.formSs.fileName, viewEntity.formSs.filePath),
          });
        }
        if (viewEntity.pageTypeId) {
          PageType.get(viewEntity.pageTypeId).then((response) => {
            setPageType(response.data);
          });
        }
        if (viewEntity.formSsDetails) {
          setDataSource(DataStore.init(viewEntity.formSsDetails));
        }
        setEntity(viewEntity);
      }
    })();
  }, [props.data]);

  useEffect(() => {
    if (props.setPageTitle && pageType && entity) {
      let title = "活动结案申请";
      if (entity.formSs) {
        title += '【编辑】'
      }
      props.setPageTitle(title);
    }
  }, [props.setPageTitle, pageType, entity]);


  return (
    <>
      <SsWarningInformation {...warningSettings} />
      <ProForm
        formRef={formRef}
        submitter={{
          render: () => {
            return (
              <ApplyFooter
                setLoading={props.setLoading}
                hiddenButton={[ApplyFooterType.Validate]}
                viewEntity={entity}
                submitBackUrl="/sales/ss/mysettle"
                doSubmit={async (type: number, forceSubmit: boolean) => {
                  if (!entity || !pageType || !dataSource) {
                    return;
                  }
                  const remark = await editorRef?.current?.getHtml?.();
                  const values = await formRef.current?.validateFieldsReturnFormatValue?.();
                  if (values && values.errorFields && values.errorFields.length) {
                    return;
                  }
                  const statusId = type === ApplyFooterType.Draft ? Enum.FormStatus.DRAFT : Enum.FormStatus.AWAITING;
                  values.remark = remark;
                  const req = getPageResult(values, entity, pageType, statusId, dataSource);
                  if (req.code !== ResponseStatus.SUCCESS) {
                    message.error(req.message);
                    return;
                  }
                  props?.setLoading?.(true);
                  return await FormSs.Buttons.apply({
                    forceSubmit: forceSubmit,
                    ...req.data
                  });
                }}
                del={async () => {
                  if (!entity || !entity.formId) {
                    return;
                  }
                  return await FormSs.Buttons.del(entity.formId);
                }}

                showWarning={(result: WdiModalAppResult, submitCallback: any) => {
                  setWarningSettings({
                    visible: true,
                    title: "警示信息",
                    wdiPanelList: result.data,
                    onClose: () => {
                      setWarningSettings({visible: false});
                    },
                    onSave: async () => {
                      await submitCallback();
                    },
                  });
                }}
              />
            )
          }
        }}
      >
        <FormSaInfosApp formRef={formRef} defaultCollapsed={true} formSaId={entity?.formSaId}/>
        <WdiPanel collapsed={false} title={<WdiCardTitle iconType={Enum.IconType.FORM_SS} title='活动结案单信息'/>}>
          <Row gutter={[16, 24]}>
            <Col className="gutter-row" span={8}>
              <Form.Item name="remark" label="活动效果说明"
                         rules={[{required: true, message: '活动效果说明不能为空!'}]}>
                <WdiEditor setRef={setEditorRef}/>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={8}>
              <Form.Item name="differenceDesc" label="整体差异说明">
                <TextArea rows={4} maxLength={2000}/>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={8}>
              <Form.Item
                name="fileInfo"
                label="附件"
                valuePropName='fileList'
                getValueFromEvent={(e: any) => {
                  return e.fileList || [];
                }}
              >
                <WdiFileUpload leftTopInfo="请选择文件并上传(单个文件不能超500M)" multiple={true}/>
              </Form.Item>
            </Col>
          </Row>
        </WdiPanel>
        <GeneralSettleDetailsForApplyApp
          data={{
            pageTypeId: pageType?.pageTypeId,
            formSaId: entity?.formSaId,
            formSsId: entity?.formSs?.formSsId,
            ecFieldConfigs: entity?.ecFieldConfigs
          }}
          dataSource={dataSource}
          onChange={onDetailsChange}/>
      </ProForm>
    </>
  );
};
export default GeneralSettleApplyApp;

